import { useMemo, useState, useCallback } from "react";

import { Container, Row } from "reactstrap";

// RangeSlider
import "nouislider/distribute/nouislider.css";
import DeleteModal from "../../Components/Common/DeleteModal";
import TableContainer from "../../Components/Common/TableContainer";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Loader from "../../Components/Common/Loader";
import {
  useDeleteInnovation,
  useInnovations,
} from "../../hooks/useInnovations";
import { getStoredAuthUser } from "../../utils/backendApi";

import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import { red } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { normalizeBackendFileUrl } from "../../utils/backendApi";
import defaultIllustration from "../../assets/images/lcbtp.png";

const Innovations = (props) => {
  const innovationsQ = useInnovations();
  const deleteMutation = useDeleteInnovation();

  const rawInnovations = innovationsQ.data || [];
  const innovations = Array.isArray(rawInnovations)
    ? rawInnovations
    : rawInnovations?.results ?? [];

  const [innovation, setInnovation] = useState(null);

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const errorMessage =
    typeof innovationsQ.error === "string"
      ? innovationsQ.error
      : innovationsQ.error?.message || "Erreur";

  const onClickDelete = useCallback((innovationItem) => {
    setInnovation(innovationItem);
    setDeleteModal(true);
  }, []);

  const handleDeleteProduct = () => {
    if (!innovation?.id) return;
    deleteMutation.mutate(innovation.id, {
      onSettled: () => setDeleteModal(false),
    });
  };

  const role = (getStoredAuthUser()?.role ?? []).some(
    (role) => role === "assistant"
  );

  // Delete Multiple
  const deleteMultiple = async () => {
    const ele = document.querySelectorAll(".entrepriseCheckBox:checked");
    const del = document.getElementById("selection-element");

    const ids = Array.from(ele)
      .map((e) => e?.value)
      .filter(Boolean);

    try {
      await Promise.all(ids.map((id) => deleteMutation.mutateAsync(id)));
    } catch (_) {
      // handled by toast
    } finally {
      if (del) del.style.display = "none";
      const checkall = document.getElementById("checkBoxAll");
      if (checkall) checkall.checked = false;
      const all = document.querySelectorAll(".entrepriseCheckBox");
      all.forEach((e) => {
        e.checked = false;
      });
    }
  };

  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".entrepriseCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type="checkbox"
            id="checkBoxAll"
            onClick={() => checkedAll()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type="checkbox"
              className="entrepriseCheckBox"
              value={cellProps.row.original.id}
            />
          );
        },
        id: "#",
      },
      {
        Header: props.t("ILLUSTRATION"),
        Cell: (innovation) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <img
                  src={
                    normalizeBackendFileUrl(
                      innovation.row.original.innovation_pic
                    ) || defaultIllustration
                  }
                  alt={props.t("Illustration")}
                  className="avatar-sm rounded"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = defaultIllustration;
                  }}
                />
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("TITRE"),
        accessor: "label",
        Cell: (innovation) => (
          <>
            <div
              className="d-flex align-items-center"
              style={{
                width: 200,
                height: 50,
                overflow: "clip",
                verticalAlign: "middle",
                textTransform: "uppercase",
              }}
            >
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1">
                  <b style={{ fontWeight: "bold" }}>
                    {innovation.row.original.label}
                  </b>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("DESCRIPTION"),
        accessor: "description",
        Cell: (innovation) => (
          <div className="d-flex align-items-center">
            <div className="flex-grow-1">
              <h5
                className="fs-14 mb-1"
                style={{
                  width: 200,
                  height: 50,
                  overflow: "clip",
                  verticalAlign: "middle",
                }}
              >
                <Link
                  to={`/#/${innovation.row.original.id}/`}
                  className="text-dark"
                ></Link>
                {innovation.row.original.description}
              </h5>
            </div>
          </div>
        ),
      },
      {
        Header: props.t("STATUT"),
        Cell: (innovation) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                {innovation.row.original.published === false ? (
                  <div>
                    <h5 className="mb-1 badge badge-soft-warning me-1 ">
                      En attente
                    </h5>
                  </div>
                ) : (
                  <p className="mb-1 badge badge-soft-success me-1"> Publiée</p>
                )}
              </div>
            </div>
          </>
        ),
      },
      {
        Header: " ",
        Cell: (innovation) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14  p-2">
                  <span className="mt-4">
                    {innovation.row.original.published === false && !role && (
                      <div>
                        <div className="btn btn-soft-success">
                          <Link
                            to={`/innovations-details/${innovation.row.original.id}`}
                          >
                            Publier
                          </Link>
                        </div>
                      </div>
                    )}
                  </span>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: props.t("AUTEUR"),
        accessor: "innovator",
        Cell: (innovation) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <h5 className="fs-14 mb-1 ">
                  <i className="p-2 align-items-center ">
                    {innovation.row.original.innovator
                      ? innovation.row.original.innovator.username
                      : "-"}
                  </i>
                </h5>
              </div>
            </div>
          </>
        ),
      },
      {
        Header: "ACTIONS",
        Cell: (cellProps) => {
          const innovationsData = cellProps.row.original;
          return (
            <>
              <li className="list-inline-item" title={props.t("Modifier")}>
                <Link
                  to={`/innovations-update/${innovationsData.id}`}
                  className="text-warning d-inline-block"
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </Link>
              </li>
              <li className="list-inline-item" title={props.t("Voir")}>
                <Link
                  to={`/innovations-details/${innovationsData.id}`}
                  className="text-success d-inline-block"
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li>
              <Link
                to="#"
                className="text-danger d-inline-block"
                onClick={() => onClickDelete(innovationsData)}
              >
                <i className="ri-delete-bin-5-line me-2 align-middle text-danger"></i>
              </Link>
            </>
          );
        },
      },
    ],
    [props, role, checkedAll, onClickDelete]
  );

  document.title = props.t("Liste des innovations");

  if (innovationsQ.isLoading) return <Loader />;
  if (innovationsQ.isError) return <Loader error={errorMessage} />;

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteProduct}
        onCloseClick={() => setDeleteModal(false)}
        isPending={deleteMutation.isPending}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb
          title={props.t("Liste des innovations")}
          pageTitle={props.t("Listes des innovations")}
        />
        <Row>
          <div className="col-xl-12 col-lg-12">
            <div>
              <div className="card">
                <div className="card-body pt-0">
                  {innovations && innovations.length > 0 ? (
                    <div>
                      <TableContainer
                        columns={columns}
                        data={innovations || []}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={10}
                        divClass="table-responsive mb-1"
                        tableClass="mb-0 align-middle"
                        theadClass="table-light text-muted"
                        isInnovationFilter={true}
                      />
                    </div>
                  ) : (
                    <div className="py-4 text-center">
                      <div className="mt-4">
                        <h5>{props.t("Désolé, pas de resultats trouvés")}</h5>
                      </div>
                      <div className="mt-4">
                        <Link to="/innovations-add" className="btn btn-warning">
                          <i className="ri-add-line align-bottom me-1"></i>{" "}
                          {props.t("Ajouter une innovation")}
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};
Innovations.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(Innovations));
